import { render, staticRenderFns } from "./AdmissionExaminationRoom.vue?vue&type=template&id=2ef77335&"
import script from "./AdmissionExaminationRoom.vue?vue&type=script&lang=js&"
export * from "./AdmissionExaminationRoom.vue?vue&type=script&lang=js&"
import style0 from "./AdmissionExaminationRoom.vue?vue&type=style&index=0&id=2ef77335&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports